var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.16665V7.33331C5.5 4.29915 6.41667 1.83331 11 1.83331C15.5833 1.83331 16.5 4.29915 16.5 7.33331V9.16665",
    stroke: "#A4A5A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.9583C12.2656 16.9583 13.2916 15.9323 13.2916 14.6667C13.2916 13.401 12.2656 12.375 11 12.375C9.73433 12.375 8.70831 13.401 8.70831 14.6667C8.70831 15.9323 9.73433 16.9583 11 16.9583Z",
    stroke: "#A4A5A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 20.1667H6.41665C2.74998 20.1667 1.83331 19.25 1.83331 15.5834V13.75C1.83331 10.0834 2.74998 9.16669 6.41665 9.16669H15.5833C19.25 9.16669 20.1666 10.0834 20.1666 13.75V15.5834C20.1666 19.25 19.25 20.1667 15.5833 20.1667Z",
    stroke: "#A4A5A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.3f025b000037b1bacc4c19e43ac64f81.svg";
export { ForwardRef as ReactComponent };